import React from "react";
import { Typography, Card, Tooltip, CardContent } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { DownloadIcon, LinkIcon } from "@icarius-icons";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import _ from "@lodash";

const CARD_HEIGHT = 305;
const IMAGE_HEIGHT = 125;

const DownloadLinkItem = (props) => {
    const { name, text, image, attachment, attachmentIsLink, onClick } = props;

    const color = useSelector(getAppColor);

    const imageContainerFullStyle = {
        backgroundImage: "url('" + image + "')",
        backgroundSize: "cover",
    };

    return (
        <Card
            onClick={text ? onClick : null}
            style={{
                width: "100%",
                borderRadius: 15,
                cursor: "pointer",
                height: CARD_HEIGHT,
            }}
        >
            <div
                className={"image-container"}
                style={{
                    backgroundColor: color,
                    cursor: !attachmentIsLink ? "pointer" : "",
                    height: `${IMAGE_HEIGHT}px`,
                    ...(image ? imageContainerFullStyle : {}),
                }}
            >
                {Boolean(attachment) && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                            backgroundColor: image ? "rgba(0, 0, 0, 0.5)" : "transparent",
                        }}
                    >
                        <Typography
                            variant="caption"
                            style={{
                                color: "white",
                                cursor: "pointer",
                                textDecoration: "underline",
                                wordBreak: "break-word",
                                maxWidth: "80%",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            {attachmentIsLink ? (
                                <LinkIcon className={"download-icon"} />
                            ) : (
                                <DownloadIcon className={"download-icon"} />
                            )}
                            {attachmentIsLink
                                ? _.truncate(attachment.replace(/<(?:.|\n)*?>/gm, ""), { length: 30 })
                                : getLocalizedString("downloadAttachment")}
                        </Typography>
                    </div>
                )}
            </div>
            <CardContent
                style={{
                    height: `calc(${CARD_HEIGHT}px - ${IMAGE_HEIGHT}px - 40px)`,
                    paddingBottom: 15,
                }}
            >
                <Tooltip title={name} arrow>
                    <Typography
                        className="whiteText"
                        align="center"
                        style={{
                            fontSize: 18,
                            overflow: "hidden",
                            display: "-webkit-box" /* Required for the clamping mechanism */,
                            WebkitBoxOrient: "vertical" /* Required for the clamping mechanism */,
                            WebkitLineClamp: 1 /* The number of lines to show */,
                            lineClamp: 1 /* Standard property for future support */,
                            width: "100%",
                        }}
                    >
                        {name}
                    </Typography>
                </Tooltip>
                <div
                    style={{
                        background: "var(--tertiaryBackgroundColor)",
                        border: "1px solid var(--borderColor)",
                        borderRadius: 15,
                        padding: 15,
                        marginTop: 15,
                        height: 75,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Tooltip title={text} arrow>
                        <Typography
                            className="whiteText"
                            align="center"
                            style={{
                                fontSize: 15,
                                overflow: "hidden",
                                display: "-webkit-box" /* Required for the clamping mechanism */,
                                WebkitBoxOrient: "vertical" /* Required for the clamping mechanism */,
                                WebkitLineClamp: 3 /* The number of lines to show */,
                                lineClamp: 3 /* Standard property for future support */,
                                width: "100%",
                            }}
                        >
                            {text}
                        </Typography>
                    </Tooltip>
                </div>
            </CardContent>
        </Card>
    );
};

export default DownloadLinkItem;
